












































import mixins from 'vue-typed-mixins'
import validationMixin from '@/plugins/mixins/validationMixin'
import Openable from '@/global/viewmodels/openable'
import SendDuplicataModel from '../models/ficheImplantationDuplicata_EnvoiMail'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'

export default mixins(validationMixin, mobileTypeMixin).extend({
    props: { dialog: Openable, envoiMailDuplicata: SendDuplicataModel },
    data() {
        return { formValid: false }
    },
    methods: {
        envoyerMail() {
            if (this.formValid) {
                this.$emit('envoiMail', this.envoiMailDuplicata)
                this.dialog.close()
            }
        }
    }
})
